import { ClockCircleOutlined, CalendarOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface Props {
  days: string;
  start: string;
  end: string;
}

const BranchHours = ({ days, start, end }: Props) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";

  return (
    <div
      className="ac-branch-hours"
      dir={isAr ? "rtl" : "ltr"}
      aria-label={t("branches.workingHours")}
    >
      <div className="ac-branch-hours__header">
        <div className="ac-branch-hours__title">
          <span className="ac-branch-hours__title-mark" aria-hidden />
          <span className="ac-branch-hours__title-inner">
            <span className="ac-branch-hours__title-badge" aria-hidden>
              <ClockCircleOutlined className="ac-branch-hours__title-icon" />
            </span>
            <span className="ac-branch-hours__title-text">{t("branches.workingHours")}</span>
          </span>
        </div>
      </div>
      <div className="ac-branch-hours__body">
        <div className="ac-branch-hours__item ac-branch-hours__item--days">
          <span className="ac-branch-hours__label">
            <CalendarOutlined className="ac-branch-hours__item-icon" aria-hidden />
            {t("branches.workingDays")}
          </span>
          <div className="ac-branch-hours__value-shell">
            <p className={`ac-branch-hours__value ${isAr ? "ac--font-expo" : ""}`}>
              {days}
            </p>
          </div>
        </div>
        <div className="ac-branch-hours__divider" aria-hidden />
        <div className="ac-branch-hours__item ac-branch-hours__item--time">
          <span className="ac-branch-hours__label">
            <ClockCircleOutlined className="ac-branch-hours__item-icon" aria-hidden />
            {t("branches.openingHours")}
          </span>
          <div className="ac-branch-hours__value-shell ac-branch-hours__value-shell--time">
            <div
              className={`ac-branch-hours__time-row ${isAr ? "ac--font-expo" : ""}`}
              role="group"
              aria-label={t("branches.openingHours")}
            >
              <span className="ac-branch-hours__time-chip ac-branch-hours__time-range">{start}</span>
              <span className="ac-branch-hours__time-connector" aria-hidden>
                {t("branches.timeSeparator")}
              </span>
              <span className="ac-branch-hours__time-chip ac-branch-hours__time-range">{end}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchHours;
